import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "image", "images" ]
  
  connect() {
    this.mainImgIndex = 0
    console.log('Carousel connected, total items:', this.imagesTargets.length)
    // Initialize with first element
    this.updateImgs()
  }

  select(event) {
    const selectedElement = event.target.closest('[data-carousel-target="images"]')
    this.mainImgIndex = [...this.imagesTargets].indexOf(selectedElement)
    console.log('Selected index:', this.mainImgIndex)
    this.updateImgs()
  }

  updateImgs(){
    // Bounds checking
    if (this.mainImgIndex < 0) {
      this.mainImgIndex = this.imagesTargets.length - 1
    }
    if (this.mainImgIndex >= this.imagesTargets.length) {
      this.mainImgIndex = 0
    }

    console.log('Updating to index:', this.mainImgIndex, 'of', this.imagesTargets.length)

    this.imagesTargets.forEach(item => {
      item.classList.remove("active")
    });
    
    const selectedElement = this.imagesTargets[this.mainImgIndex];
    if (!selectedElement) {
      console.error('No element found at index:', this.mainImgIndex)
      return
    }
    
    selectedElement.classList.add("active")
    
    // Get main image and video containers
    const mainImage = document.getElementById('image-show')
    const mainVideo = document.getElementById('video-show')
    
    console.log('Selected element classes:', selectedElement.className)
    console.log('Is video thumbnail:', selectedElement.classList.contains('video-thumbnail'))
    
    // Check if selected element is video thumbnail
    if (selectedElement.classList.contains('video-thumbnail')) {
      // Show video, hide image
      console.log('Showing video')
      if (mainVideo) {
        mainVideo.style.display = 'block'
      }
      if (mainImage) {
        mainImage.style.display = 'none'
      }
    } else {
      // Show image, hide video
      console.log('Showing image:', selectedElement.src)
      if (mainVideo) {
        mainVideo.style.display = 'none'
      }
      if (mainImage) {
        mainImage.style.display = 'block'
        mainImage.src = selectedElement.src
      }
    }
    
    selectedElement.parentNode.scrollTo({ left: selectedElement.offsetLeft - selectedElement.width, behavior: 'smooth' });
  }

  next() {
    console.log('Next clicked, current index:', this.mainImgIndex)
    this.mainImgIndex += 1
    this.updateImgs()
  }

  previous() {
    console.log('Previous clicked, current index:', this.mainImgIndex)
    this.mainImgIndex -= 1
    this.updateImgs()
  }
}
